/*=========================================================================================
  File Name: moduleSpaceState.js
  Description: Space Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ActiveNoticeBoard: {
      question:'게시글1',
      answer:'',
      id:0
  },
  noticeBoards: [],
  noticeBoardSearchQuery: {
    keywoard:'',
    id:0,
    state:0
  },
}
